<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title" *ngIf="header && header !== ''">{{ header }}</div>
    <div *ngIf="body" class="club-info">
        <img [src]="body.imageUrl || '/assets/icon/default_club_image.webp'" class="club-image" />
        <div class="club-row">
            <div class="club-field">Name: </div>
            <div class="club-value">{{ body.name }}</div>
        </div>
        <div class="club-row">
            <div class="club-field">Club Code: </div>
            <div class="club-value">{{ body.clubCode }}</div>
        </div>
        <div class="club-row">
            <div class="club-field">Members: </div>
            <div class="club-value">{{ body.memberCount }}</div>
        </div>
        <div class="club-row">
            <div class="club-field">Created: </div>
            <div class="club-value">{{ body.creationDate | sopoDate: sopoDateTimeOptions }}</div>
        </div>
    </div>
    <div class="sopo-popup-button-container">
        <div class="sopo-popup-green-button ion-activatable clickable" (click)="close(true)">
            {{ okText }}
            <ion-ripple-effect></ion-ripple-effect>
        </div>
        <div class="sopo-popup-red-button ion-activatable clickable" (click)="close(false)">
            {{ cancelText }}
            <ion-ripple-effect></ion-ripple-effect>
        </div>
    </div>
</div>